import React from "react";
import { Outlet } from "react-router-dom";

import HeaderPage from "components/HeaderPage";
import FooterPage from "components/FooterPage";

export default function Layout() {
  return (
    <>
      <HeaderPage />

      <Outlet />

      <FooterPage />
    </>
  );
}
